import { PureAbility } from "@casl/ability";
import { PLAN_FUNCTIONS } from "@/helpers/constant";

export default new PureAbility(
  PLAN_FUNCTIONS.map((planFunction) => {
    return {
      action: planFunction,
      subject: "all",
    };
  }),
);
